<form [formGroup]="menuService?.form" (ngSubmit)="saveAndContinue()" class="px-0 px-sm-3"
    [ngClass]="{ 'py-5 position-relative': isDialog }">
    <div class="container-fluid px-0 px-md-3">
        <i matTooltip="Cerrar" class="fas fa-times fa-2xl close-icon-actions" *ngIf="isDialog"
            (click)="dialogRef.close()"></i>
        <h4 *ngIf="isDialog" class="text-bold text-center px-3">
            Manifiesto y operación
        </h4>
        <div class="alert alert-info pt-4 pb-3 mt-3" *ngIf="documentRecreationInProgress" role="status">
            <div class="d-flex align-items-start">
                <i class="fas fa-sync-alt fa-spin mr-3 mt-1"></i>
                <div>
                    <div class="text-bold">{{documentRecreationInProgressTitle}}</div>
                    <div>{{documentRecreationInProgressMessage}}</div>
                    <small>Crear, editar, eliminar y retransmitir documentos está temporalmente bloqueado.</small>
                </div>
            </div>
        </div>
        <div class="row" *ngIf="canShowConsignmentServiceModule">
            <p class="col-md-12 text-bold">Información de manifiesto</p>
            <mat-form-field appearance="outline" class="col-md-6">
                <mat-label>Tipo de manifiesto<span class="asterisk">*</span></mat-label>
                <mat-select [formControl]="manifestType" [compareWith]="compareByCode">
                    <mat-option *ngFor="let option of manifestTypesFiltered" [value]="option">
                        <i matPrefix class="fas fa-info-circle color-secondary-dark cursor-pointer"
                            [matTooltip]="option.tooltip" matTooltipClass="tooltip__alert"
                            matTooltipPosition="left"></i>
                        {{ option.description }}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="manifestType?.errors?.required">
                    {{ utils.giveMessageError('MANDATORY_FIELD') }}
                </mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="col-md-6"
                *ngIf="manifestType.value && manifestType.value.code === 'D'">
                <mat-label>Número de viajes<span class="asterisk">*</span></mat-label>
                <input matInput type="number" [formControl]="manifestDailyTripsCount" min="1" />
                <mat-error *ngIf="manifestDailyTripsCount?.errors?.required">
                    {{ utils.giveMessageError('MANDATORY_FIELD') }}
                </mat-error>
                <mat-error *ngIf="manifestDailyTripsCount?.errors?.min">
                    El número de viajes debe ser mayor a 0
                </mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="col-md-6">
                <mat-label>Tipo de operación <span class="optional">(opcional)</span></mat-label>
                <mat-select [formControl]="operationType" [compareWith]="compareByCode">
                    <mat-option *ngFor="let option of operationTypeOptions" [value]="option">
                        <i matPrefix class="fas fa-info-circle color-secondary-dark cursor-pointer"
                            [matTooltip]="option.tooltip" matTooltipClass="tooltip__alert"
                            matTooltipPosition="left"></i>
                        {{ option.description }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <div class="col-12 p-0">
                <app-monitoring-company-selector [monitoringCompanyControl]="monitoringCompanyControl"
                    [validate]="formValidate" [initialValue]="initialMonitoringValue">
                </app-monitoring-company-selector>
            </div>
            <div class="col-12 px-0 d-flex flex-wrap" *ngIf="!isDialog">
                <p class="alert alert-danger col-12 text-bold text-center" role="alert"
                    *ngIf="canEditConsignmentServiceModule && !canEditConsignments">
                    <i class="fas fa-exclamation-circle"></i>
                    Debes completar la información del contratante del servicio para poder agregar y editar remesas
                </p>
                <app-consignment-card *ngFor="let consignment of filteredConsignmentsFormArray;let i=index"
                    class="col-12 consignment-container" [ngClass]="{'border-top-gray': !i}" [form]="consignment"
                    [title]="getTitleConsignment(consignment.value, i)" [formValidate]="formValidate"
                    [senderCityOptions]="senderCityOptions" [recipientCityOptions]="recipientCityOptions"
                    (removeConsignmentForm)="removeConsignmentForm(i)" [canDeleteConsignment]="canEditConsignments"
                    [cargo]="menuService?.cargo">
                </app-consignment-card>
                <p class="text-bold font-secondary-dark col-12 pl-2 mb-2 text-center cursor-pointer"
                    (click)="watchMoreConsignments()" *ngIf="numberOfConsignmentsShowed < consignmentsFormArray.length">
                    <span>Ver más remesas</span>
                </p>
                <p class="text-bold font-secondary-dark pl-2 cursor-pointer" (click)="addConsignmentForm()"
                    *ngIf="canEditConsignments && numberOfConsignmentsShowed >= consignmentsFormArray.length">
                    <i class="fas fa-plus-circle"></i>
                    <span>Agregar {{consignmentsFormArray?.length ? 'otra ': ''}}remesa</span>
                </p>
            </div>
        </div>
        <div *ngIf="!canShowConsignmentServiceModule" class="no-permission-container">
            <i class="fas fa-exclamation-circle fa-lg m-2"></i>
            <h4 class="text-bold">No tienes permiso para acceder a esta información. Contacta a tu administrador para
                solicitar acceso.</h4>
        </div>
        <!-- Action buttons -->
        <div class="button-container mt-4" *ngIf="!isDialog; else dialogButtons">
            <button mat-raised-button color="primary" class="button-width-auto primary-secondary button-small"
                [ngClass]="{'warn': true}" type="button" (click)="backToPreviousStep()">
                <span class="mat-button-wrapper">Atras</span>
            </button>
            <button class="mx-2" type="submit" mat-raised-button color="accent"
                [disabled]="documentRecreationInProgress" *ngIf="canEditConsignmentServiceModule">
                Guardar y Continuar
            </button>
            <button class="mx-2" type="button" mat-raised-button color="accent" (click)="continueToNextStep()"
                *ngIf="!canEditConsignmentServiceModule">
                Continuar
            </button>
        </div>
        <ng-template #dialogButtons>
            <div class="button-container mt-4">
                <button class="mx-2" type="submit" mat-raised-button color="accent"
                    [disabled]="documentRecreationInProgress">
                    Guardar
                </button>
            </div>
        </ng-template>
    </div>
</form>
